"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForm = useForm;

var _react = require("react");

var _getLookup = _interopRequireDefault(require("get-lookup"));

var _reducer = _interopRequireWildcard(require("./reducer"));

var _validations = require("./validations");

var _buildPartialHook = _interopRequireDefault(require("./buildPartialHook"));

var _HandlersCache = _interopRequireDefault(require("./HandlersCache"));

var _config = require("./config");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useForm() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.DEFAULT_CONFIG;
  var secondaryConfig = arguments.length > 1 ? arguments[1] : undefined;
  var initial = (0, _react.useMemo)(function () {
    return (0, _reducer.init)(config, secondaryConfig);
  }, []);

  var _useReducer = (0, _react.useReducer)(_reducer["default"], initial),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      attrs = _useReducer2$.attrs,
      errors = _useReducer2$.errors,
      isPristine = _useReducer2$.isPristine,
      pureHandlers = _useReducer2$.pureHandlers,
      helpers = _useReducer2$.helpers,
      action = _useReducer2$.action,
      validating = _useReducer2$.validating,
      dispatch = _useReducer2[1];

  var isValid = !Object.values(errors).some(Boolean);
  var unmountedRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    return function () {
      return unmountedRef.current = true;
    };
  }, []);
  var dispatchIfMounted = (0, _react.useCallback)(function (action) {
    if (unmountedRef.current) return;
    dispatch(action);
  }, []);
  var handlersCache = (0, _react.useMemo)(function () {
    return new _HandlersCache["default"](pureHandlers);
  }, []);
  var get = (0, _react.useCallback)(function (name) {
    return name ? (0, _getLookup["default"])(attrs, name) : attrs;
  }, [attrs]);
  var set = (0, _react.useCallback)(function (pathOrAttrsOrFn, valueOrPrefix) {
    if (typeof pathOrAttrsOrFn === 'function' || _typeof(pathOrAttrsOrFn) === 'object') {
      return dispatch((0, _reducer.setAttrs)(pathOrAttrsOrFn, valueOrPrefix));
    } else {
      return dispatch((0, _reducer.setAttr)(pathOrAttrsOrFn, valueOrPrefix));
    }
  }, []); // Used in a useEffect to apply external attributes to a form.

  var setFormAttrs = (0, _react.useCallback)(function (attrs, options) {
    return dispatch((0, _reducer.setFullAttrs)(attrs, options));
  }, []);
  var validate = (0, _react.useCallback)(function () {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      async: true
    };

    if (name && _typeof(name) === 'object') {
      options = name;
      name = null;
    }

    var _options = options,
        doValidateAsync = _options.async;
    return new _validations.ValidationPromise(function (resolveValidation, rejectValidation) {
      new Promise(function (resolve, reject) {
        dispatch((0, _reducer.validate)(name, resolve, reject));
      }).then(function (attrs) {
        if (!doValidateAsync) {
          return resolveValidation(attrs);
        }

        return new Promise(function (resolve, reject) {
          dispatchIfMounted((0, _reducer.validateAsync)(name, resolve, reject));
        }).then(function (attrs) {
          dispatchIfMounted((0, _reducer.finishValidateAsync)());
          resolveValidation(attrs);
        })["catch"](function (errors) {
          dispatchIfMounted((0, _reducer.finishValidateAsync)(errors));
          rejectValidation(errors);
        });
      })["catch"](function (errors) {
        if (!doValidateAsync) {
          return rejectValidation(errors);
        }

        return new Promise(function (resolve, reject) {
          dispatchIfMounted((0, _reducer.validateAsync)(name, resolve, reject, Object.keys((0, _validations.compact)(errors))));
        }).then(function () {
          dispatchIfMounted((0, _reducer.finishValidateAsync)(errors));
          rejectValidation(errors);
        })["catch"](function (asyncErrors) {
          if (unmountedRef.current) return;

          var allErrors = _objectSpread(_objectSpread({}, errors), asyncErrors);

          dispatchIfMounted((0, _reducer.finishValidateAsync)(allErrors));
          rejectValidation(allErrors);
        });
      });
    });
  }, []);
  var getError = (0, _react.useCallback)(function (name) {
    return errors[name];
  }, [errors]);
  var setError = (0, _react.useCallback)(function (name, error) {
    return new Promise(function (resolve) {
      dispatch((0, _reducer.setError)(name, error));
      resolve(_defineProperty({}, name, error));
    });
  }, []);
  var setErrors = (0, _react.useCallback)(function (errors) {
    if (errors && _typeof(errors) === 'object' && errors.constructor === Object) {
      return new Promise(function (resolve) {
        dispatch((0, _reducer.setErrors)(errors));
        resolve(errors);
      });
    }

    throw errors;
  }, []);
  var dropError = (0, _react.useCallback)(function (name) {
    return dispatch((0, _reducer.setError)(name, undefined));
  }, []);
  var reset = (0, _react.useCallback)(function (attrsOrFn) {
    return dispatch((0, _reducer.reset)(attrsOrFn));
  }, []);
  var setState = (0, _react.useCallback)(function (setter) {
    return dispatch((0, _reducer.setState)(setter));
  }, []);

  var withValidation = function withValidation(callback) {
    return function () {
      return validate().then(callback);
    };
  };

  var defaultOnChange = (0, _react.useCallback)(function (value, _ref) {
    var name = _ref.name;
    return set(name, value);
  }, []);

  var input = function input(name) {
    var onChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOnChange;
    return {
      value: get(name),
      onChange: handlersCache.fetch(name, onChange, function () {
        return function (value, meta) {
          return onChange(value, _objectSpread(_objectSpread({}, meta), {}, {
            name: name
          }));
        };
      }),
      error: errors[name],
      name: name
    };
  };

  var usePartial = (0, _buildPartialHook["default"])({
    dispatch: dispatch,
    get: get,
    set: set,
    getError: getError,
    input: input
  });

  var useConfig = function useConfig(fn, deps) {
    (0, _react.useEffect)(function () {
      var config = (0, _config.resolveConfig)(fn());
      dispatch((0, _reducer.addConfig)(config));
      return function () {
        dispatch((0, _reducer.removeConfig)(config));
      };
    }, deps);
  };

  var _amendInitialConfig = (0, _react.useCallback)(function (config) {
    if (config !== secondaryConfig) {
      dispatch((0, _reducer.amendInitialConfig)((0, _config.resolveConfig)(config)));
    }
  }, []);

  var formHelpers = {
    attrs: attrs,
    get: get,
    set: set,
    isPristine: isPristine,
    setFormAttrs: setFormAttrs,
    errors: errors,
    getError: getError,
    setError: setError,
    setErrors: setErrors,
    dropError: dropError,
    isValid: isValid,
    reset: reset,
    setState: setState,
    usePartial: usePartial,
    useConfig: useConfig,
    validate: validate,
    validating: validating,
    withValidation: withValidation,
    input: input,
    $: input,
    _amendInitialConfig: _amendInitialConfig,
    _action: action
  };
  return helpers.reduce(function (hlp, fn) {
    return _objectSpread(_objectSpread({}, hlp), fn(hlp));
  }, formHelpers);
}